import { createRawAPIClient } from '@portal-packages/api';

import { CredentialsProvider } from 'modules/Session';
import { getBffWebUrl } from 'utils/domain-utils';
import { createRefreshTokenInterceptor } from 'utils/token';

const client = createRawAPIClient({ baseURL: getBffWebUrl() });

client.instance.interceptors.request.use(async (config) => {
  if (config.withCredentials === false) {
    return config;
  }

  config.headers = {
    ...CredentialsProvider.getAuthorizationHeader(),
    ...config.headers,
  };

  return config;
}, Promise.reject);

client.instance.interceptors.response.use(...createRefreshTokenInterceptor(client.instance));

export const API_CLIENTS = {
  APP: client,
};
